export const DROPDOWN = "dropdown";
export const RADIO_HORIZTONAL = "radiobuttonhorizontal";
export const RADIO_VERTICAL = "radiobuttonvertical";
export const NUMERIC_TEXTBOX = "numerictextbox";
export const TEXTBOX = "textbox";
export const TEXTAREA = "textarea";
export const CHECKBOX = "checkbox";
export const IMAGE_TEXT_HORIZONTAL = "imageandtexthorizontal";
export const IMAGE_TEXT_WRAP = "imageandtextwrap";
export const NUMERIC_CONTROL = "numericcontrol";
export const TYPEABLE_DROPDOWN = "typeabledropdown";
export const IMAGE_DROPDOWN = "imagedropdown";
export const HOME_DELIVERY = "Home Delivery";

export const PLACEHOLDER = "placeholder";

// Access this value with roleLevel 0-9
export const DEFAULT_HOMEPAGE = {
  0: "/QuoteDashboard",
  1: "/QuoteDashboard",
  2: "/QuoteDashboard",
  3: "/QuoteDashboard",
  4: "/QuoteDashboard",
  5: "/QuoteDashboard",
  6: "/QuoteDashboard", 
  7: "/QuoteDashboard",
  8: "/QuoteDashboard",
  9: "/QuoteDashboard",
};

export const CONFIGURATOR_MODES = {
  Default: 0,
  Quote: 1,
  Order: 2,
  Ice: 3,
};

export const AUTO_CONTINUE_MODE = {
  StayOnScreenRule: 0,
  StayOnTab: 1,
  MoveTabAndScreenRule: 2,
};

export const MESSAGE_RULE_TYPES = {
  Critical: 1,
  Warning: 2,
  Information: 3,
};

export const rentechTheme = {
  buttonColor: "#EEEEEE",
  altButtonColor: "#6D6E71",
  buttonTextWhite: "#FFF",
  activeStageColor: "#13cdfd",
  inactiveStageForeColor: "#000",
  activeStageForeColor: "#FFF",
  completedStageColor: "#EEEEEE",
  incompleteStageColor: "#EEEEEE",
  accentColor: "#ffdd00",
  darkBackground: "#6D6E71",
  lightBackground: "#EEEEEE",
  gridLineHoverBackgroundColor: "#4d4d4d",
  gridLineHoverOpacity: 0.7,
  gridLineHoverColor: "#FFF",
  gridRowBackgroundColor: "#f5f5f5", //offwhite
  gridRowAlternateBackgroundColor: "#FFF",

  callToActionColor: "#FDB813", //Trinity Orange
  backgroundColor: "#FFF", //White
  backgroundOffset: "#EEEEEE", //Light Grey
  darkerOffset: "#D3D3D3", //Grey
  currentHighlight: "#13cdfd", //Electric Blue
  textDark: "#000", //Black
  textLight: "#FFF", //White
};
